import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCurrentUser } from "../../../context/user/UserContext"

export default function UsMostHelpfulIsUsStep(): JSX.Element {
  const { isUsa } = useCurrentUser()
  const { send } = useStateMachine()
  useEffect(() => {
    send(isUsa ? "YES" : "NO")
  })
  return <></>
}
